import { render, staticRenderFns } from "./PaymentDetails.vue?vue&type=template&id=82a66710&scoped=true"
import script from "./PaymentDetails.vue?vue&type=script&lang=js"
export * from "./PaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetails.vue?vue&type=style&index=0&id=82a66710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a66710",
  null
  
)

export default component.exports